import { useQuery } from '@tanstack/react-query';
import { diContainer } from 'src/inversify.config';
import ProductsRepository from 'features/products/data/ProductsRepository';
import { StoreStockParams } from 'features/products/domain/ProductsRepositoryInterface';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import useAppVersion from 'src/common/hooks/useAppVersion';
import { useFeatureValue } from '@growthbook/growthbook-react';
import {
  FEATURE_FLAGS_TYPE,
  FEATURE_FLAGS,
} from 'src/utils/growthBook/growthBook.constants';
import filterProductsInReview from 'src/utils/products/filterProductsInReview';

const productsRepository =
  diContainer.get<ProductsRepository>(ProductsRepository);

export default function useSearchProducts({
  storeSlug,
  ...params
}: StoreStockParams) {
  const { session } = useAuthContext();
  const { isInReview } = useAppVersion();
  const categoriesInReview = useFeatureValue<
    FEATURE_FLAGS_TYPE['REVIEW_CATEGORIES']
  >(FEATURE_FLAGS.REVIEW_CATEGORIES, { slug: [] });

  const query = useQuery({
    queryKey: [
      'products',
      { storeSlug, params, shouldFilter: isInReview, categoriesInReview },
    ],
    queryFn: () =>
      productsRepository.getStoreStock({
        storeSlug: storeSlug as string,
        token: session?.accessToken as string,
        ...params,
      }),
    enabled: !!storeSlug,
  });

  const products = query.data?.results || [];
  const filteredProducts = isInReview
    ? filterProductsInReview({
        products,
        categoriesInReview: categoriesInReview.slug,
      })
    : products;

  return {
    ...query,
    products: filteredProducts,
  };
}
